import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = {
    text: String,
  };

  copy() {
    const text = this.textValue || this.element.innerText.trim();
    navigator.clipboard?.writeText(text);
  }
}
